import React, { useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import { AppSettings } from "./../../config/app-settings.js";
import { slideUp } from "./../../composables/slideUp.js";
import { slideToggle } from "./../../composables/slideToggle.js";
import SidebarMinifyBtn from "./sidebar-minify-btn.jsx";
import SidebarProfile from "./sidebar-profile.jsx";
import SidebarNav from "./sidebar-nav.jsx";

function Sidebar() {
  const context = useContext(AppSettings);

  useEffect(() => {
    var handleSidebarMenuToggle = function (menus, expandTime) {
      menus.map(function (menu) {
        menu.onclick = function (e) {
          e.preventDefault();
          var target = this.nextElementSibling;

          menus.map(function (m) {
            var otherTarget = m.nextElementSibling;
            if (otherTarget !== target) {
              slideUp(otherTarget, expandTime);
              otherTarget.closest(".menu-item")?.classList?.remove("expand");
              otherTarget.closest(".menu-item")?.classList?.add("closed");
            }
            return true;
          });

          var targetItemElm = target.closest(".menu-item");

          if (
            targetItemElm.classList.contains("expand") ||
            (targetItemElm.classList.contains("active") &&
              !target.style.display)
          ) {
            targetItemElm.classList.remove("expand");
            targetItemElm.classList.add("closed");
            slideToggle(target, expandTime);
          } else {
            targetItemElm.classList.add("expand");
            targetItemElm.classList.remove("closed");
            slideToggle(target, expandTime);
          }
        };

        return true;
      });
    };

    var targetSidebar = document.querySelector(
      ".app-sidebar:not(.app-sidebar-end)"
    );
    var expandTime =
      targetSidebar &&
        targetSidebar.getAttribute("data-disable-slide-animation")
        ? 0
        : 300;

    var menuBaseSelector = ".app-sidebar .menu > .menu-item.has-sub";
    var submenuBaseSelector = " > .menu-submenu > .menu-item.has-sub";

    // menu
    var menuLinkSelector = menuBaseSelector + " > .menu-link";
    var menus = [].slice.call(document.querySelectorAll(menuLinkSelector));
    handleSidebarMenuToggle(menus, expandTime);

    // submenu lvl 1
    var submenuLvl1Selector = menuBaseSelector + submenuBaseSelector;
    var submenusLvl1 = [].slice.call(
      document.querySelectorAll(submenuLvl1Selector + " > .menu-link")
    );
    handleSidebarMenuToggle(submenusLvl1, expandTime);

    // submenu lvl 2
    var submenuLvl2Selector =
      menuBaseSelector + submenuBaseSelector + submenuBaseSelector;
    var submenusLvl2 = [].slice.call(
      document.querySelectorAll(submenuLvl2Selector + " > .menu-link")
    );
    handleSidebarMenuToggle(submenusLvl2, expandTime);

    var appSidebarFloatSubmenuTimeout = "";
    var appSidebarFloatSubmenuDom = "";

    function handleGetHiddenMenuHeight(elm) {
      elm.setAttribute(
        "style",
        "position: absolute; visibility: hidden; display: block !important"
      );
      var targetHeight = elm.clientHeight;
      elm.removeAttribute("style");
      return targetHeight;
    }

    function handleSidebarMinifyFloatMenuClick() {
      var elms = [].slice.call(
        document.querySelectorAll(
          "#app-sidebar-float-submenu .menu-item.has-sub > .menu-link"
        )
      );
      if (elms) {
        elms.map(function (elm) {
          elm.onclick = function (e) {
            e.preventDefault();
            var targetItem = this.closest(".menu-item");
            var target = targetItem.querySelector(".menu-submenu");
            var targetStyle = getComputedStyle(target);
            var close =
              targetStyle.getPropertyValue("display") !== "none" ? true : false;
            var expand =
              targetStyle.getPropertyValue("display") !== "none" ? false : true;

            slideToggle(target);

            var loopHeight = setInterval(function () {
              var targetMenu = document.querySelector(
                "#app-sidebar-float-submenu"
              );
              var targetMenuArrow = document.querySelector(
                "#app-sidebar-float-submenu-arrow"
              );
              var targetMenuLine = document.querySelector(
                "#app-sidebar-float-submenu-line"
              );
              var targetHeight = targetMenu.clientHeight;
              var targetOffset = targetMenu.getBoundingClientRect();
              var targetOriTop = targetMenu.getAttribute("data-offset-top");
              var targetMenuTop = targetMenu.getAttribute(
                "data-menu-offset-top"
              );
              var targetTop = targetOffset.top;
              var windowHeight = document.body.clientHeight;
              if (close) {
                if (targetTop > targetOriTop) {
                  targetTop =
                    targetTop > targetOriTop ? targetOriTop : targetTop;
                  targetMenu.style.top = targetTop + "px";
                  targetMenu.style.bottom = "auto";
                  targetMenuArrow.style.top = "20px";
                  targetMenuArrow.style.bottom = "auto";
                  targetMenuLine.style.top = "20px";
                  targetMenuLine.style.bottom = "auto";
                }
              }
              if (expand) {
                if (windowHeight - targetTop < targetHeight) {
                  var arrowBottom = windowHeight - targetMenuTop - 22;
                  targetMenu.style.top = "auto";
                  targetMenu.style.bottom = 0;
                  targetMenuArrow.style.top = "auto";
                  targetMenuArrow.style.bottom = arrowBottom + "px";
                  targetMenuLine.style.top = "20px";
                  targetMenuLine.style.bottom = arrowBottom + "px";
                }
                var floatSubmenuElm = document.querySelector(
                  "#app-sidebar-float-submenu .app-sidebar-float-submenu"
                );
                if (targetHeight > windowHeight) {
                  if (floatSubmenuElm) {
                    var splitClass = "overflow-scroll mh-100vh".split(" ");
                    for (var i = 0; i < splitClass.length; i++) {
                      floatSubmenuElm.classList.add(splitClass[i]);
                    }
                  }
                }
              }
            }, 1);
            setTimeout(function () {
              clearInterval(loopHeight);
            }, 250);
          };
          return true;
        });
      }
    }

    function handleSidebarMinifyFloatMenu() {
      // Select all menu items that have a submenu
      var menuItems = document.querySelectorAll(
        ".app-sidebar .menu > .menu-item.has-sub > .menu-link"
      );

      if (!menuItems.length) {
        //console.warn("No menu items found.");
        return;
      }

      menuItems.forEach((menuItem) => {
        menuItem.onmouseenter = function () {
          var appElm = document.querySelector(".app");

          if (!appElm || !appElm.classList.contains("app-sidebar-minified"))
            return;

          clearTimeout(appSidebarFloatSubmenuTimeout);

          var parentMenuItem = this.closest(".menu-item");
          if (!parentMenuItem) return;

          var targetMenu = parentMenuItem.querySelector(".menu-submenu");
          if (!targetMenu) {
            console.warn("No submenu found for:", parentMenuItem);
            return;
          }

          if (
            appSidebarFloatSubmenuDom === this &&
            document.querySelector("#app-sidebar-float-submenu")
          )
            return;

          appSidebarFloatSubmenuDom = this;
          var targetMenuHtml = targetMenu.innerHTML.trim();
          if (!targetMenuHtml) return;

          var sidebar = document.querySelector("#sidebar");
          if (!sidebar) return;

          var sidebarRect = sidebar.getBoundingClientRect();
          var sidebarWidth = sidebar.clientWidth;
          var windowHeight = document.documentElement.clientHeight;
          var targetRect = this.getBoundingClientRect();
          var targetTop = targetRect.top;

          var sidebarX = sidebarRect.left + sidebarWidth;
          var isRTL = getComputedStyle(document.body).direction === "rtl";
          var targetLeft = isRTL ? "auto" : sidebarX + "px";
          var targetRight = isRTL ? sidebarX + "px" : "auto";

          if (!document.querySelector("#app-sidebar-float-submenu")) {
            var floatMenu = document.createElement("div");
            floatMenu.id = "app-sidebar-float-submenu";
            floatMenu.className = "app-sidebar-float-submenu-container";
            floatMenu.setAttribute("data-offset-top", targetTop);
            floatMenu.innerHTML = `
              <div class="app-sidebar-float-submenu-arrow"></div>
              <div class="app-sidebar-float-submenu-line"></div>
              <div class="app-sidebar-float-submenu">${targetMenuHtml}</div>
            `;
            appElm.appendChild(floatMenu);

            floatMenu.onmouseover = () =>
              clearTimeout(appSidebarFloatSubmenuTimeout);
            floatMenu.onmouseout = () => {
              appSidebarFloatSubmenuTimeout = setTimeout(() => {
                document.querySelector("#app-sidebar-float-submenu")?.remove();
              }, 250);
            };
          } else {
            var existingMenu = document.querySelector(
              "#app-sidebar-float-submenu .app-sidebar-float-submenu"
            );
            if (existingMenu) existingMenu.innerHTML = targetMenuHtml;
          }

          var floatSubmenu = document.querySelector(
            "#app-sidebar-float-submenu"
          );
          if (!floatSubmenu) return;

          var submenuHeight = floatSubmenu.clientHeight;

          if (windowHeight - targetTop > submenuHeight) {
            floatSubmenu.style.top = `${targetTop}px`;
            floatSubmenu.style.bottom = "auto";
          } else {
            floatSubmenu.style.top = "auto";
            floatSubmenu.style.bottom = "0";
          }

          floatSubmenu.style.left = targetLeft;
          floatSubmenu.style.right = targetRight;
        };

        menuItem.onmouseleave = function () {
          if (
            !document
              .querySelector(".app")
              ?.classList.contains("app-sidebar-minified")
          )
            return;

          appSidebarFloatSubmenuTimeout = setTimeout(() => {
            document.querySelector("#app-sidebar-float-submenu")?.remove();
          }, 250);
        };
      });
    }

    handleSidebarMinifyFloatMenu();
  });

  return (
    <AppSettings.Consumer>
      {({
        toggleAppSidebarMinify,
        toggleAppSidebarMobile,
        appSidebarTransparent,
        appSidebarGrid,
        appSidebarLight,
      }) => (
        <React.Fragment>
          <div
            id="sidebar"
            className={
              "app-sidebar " +
              (appSidebarTransparent ? "app-sidebar-transparent" : "") +
              (appSidebarGrid ? "app-sidebar-grid" : "")
            }
            data-bs-theme={appSidebarLight ? "" : "dark"}
          >
            <PerfectScrollbar
              className="app-sidebar-content"
              options={{ suppressScrollX: true }}
            >
              {/* {!context.appSidebarSearch && <SidebarProfile />} */}
              <SidebarNav />
              <SidebarMinifyBtn />
            </PerfectScrollbar>
          </div>
          <div
            className="app-sidebar-bg"
            data-bs-theme={appSidebarLight ? "" : "dark"}
          ></div>
          <div className="app-sidebar-mobile-backdrop">
            <Link
              to="/"
              onClick={toggleAppSidebarMobile}
              className="stretched-link"
              aria-label="Toggle App Side Bar"
            ></Link>
          </div>
        </React.Fragment>
      )}
    </AppSettings.Consumer>
  );
}

export default Sidebar;
